(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'AllInclusivePropertySheetBuild',
	};

	$(document).ready(function documentReady() {
		Adzuki.Form.registerForm(form);
	});

	form.load = function load($form)
	{
		var $resort_brand   = $('#allinclusivepropertysheetbuild-vendor_id'),
		    $resort         = $('#allinclusivepropertysheetbuild-all_inclusive_property_id'),
		    $pricing_method = $("#allinclusivepropertysheetbuild-pricing_method"),
		    existing_prop_id = $resort.val();

		$resort_brand.change(function getProperties() {
			var vendor_id = $(this).val();

			$resort.prop('disabled', !(vendor_id.length > 0));
			$resort.empty();

			if (vendor_id.length > 0)
			{
				Adzuki.Ajax.get('/AllInclusiveProperties/getPropertyList/' + vendor_id)
				.then(function getPropertiesSuccess(data)
				{
					var sorted_data = Adzuki.Sort.alphabeticValue(data);

					$.each(sorted_data, function appendPropertyOptions(key, property) {
						$resort.append($('<option>').text(property.value).attr('value', property.key));
					});

					if (existing_prop_id) {
						$resort.val(existing_prop_id);
						existing_prop_id = null;
					}

					$resort.trigger('change');
				});
			}
			else {
				$resort.append($('<option>').text('Choose Resort Brand').attr('value', ''));
				$resort.trigger('change');
			}
		});

		$resort.change(function checkDestinationGuide()
		{
			var $opt         = $('#allinclusivepropertysheetbuild-show_destination_guide_option'),
			     property_id = $(this).val();

			// remove live pricing, gets re-added if the supplier supports it
			$pricing_method.find('option[value="live"]').remove();

			if (property_id)
			{
				Adzuki.Ajax.get('/AllInclusivePropertySheets/checkForGuide/' + property_id)
				.then(function showDestinationGuideOption(data) {
					if (data.guide_id) {
						$opt.val(1);
					}
					else {
						$opt.val('');
					}
				});

				Adzuki.Ajax.get('/AllInclusivePropertySheets/checkLiveBookingStatus/' + property_id)
				.then(function toggleLivePricingOption(data)
				{
					var existing_pricing_method = $pricing_method.data('existing-pricing-method');

					if (data.status)
					{
						$pricing_method.append('<option value="live">' + $pricing_method.data('live-pricing-text') + '</option>');

						if (
							!existing_pricing_method ||
							existing_pricing_method === 'live'
						) {
							$pricing_method.val('live');
						}
					}
				});
			}
			else {
				$opt.val('');
			}
		});

		$pricing_method.change(function changeSubmitText()
		{
			var $submit = $form.find('[type="submit"]');

			if (this.value === 'none') {
				$submit.html($submit.data('continue-text'));
			} else {
				$submit.html($submit.data('continue-pricing-text'));
			}
		});

		$("#allinclusivepropertysheetbuild-create_client").change(function toggleClientFields() {
			$('#client-fields').toggleClass('hidden', !(this.value === '1'));
		});

		if ($resort_brand.val()) {
			$resort_brand.trigger('change');
		}

		if ($resort.val()) {
			$resort.trigger('change');
		}
	};
}(jQuery, window.Adzuki || {}));
